import { Controller } from "@hotwired/stimulus"
import { Fancybox } from "@fancyapps/ui";

import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Connects to data-controller="fancybox"
export default class extends Controller {
  connect() {
    console.log("fancybox#connect");
    Fancybox.bind("[data-fancybox]", {
      // Your custom options
    });
  }
}
